<template>
  <div class="tw-p-4 tw-border tw-border-neutral-300 tw-rounded-lg tw-flex tw-flex-col tw-gap-4 tw-text-base">
    <slot />
  </div>
</template>